import React, { FC } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { PerformanceSummary } from '../performance.interfaces';
import { useTranslation } from 'src/hooks/useTranslationHook';

interface PerformanceQuickStatsProps {
  summary: PerformanceSummary;
}

const PerformanceQuickStats: FC<PerformanceQuickStatsProps> = ({ summary }) => {
  const { translateText } = useTranslation();
  return (
    <Grid item xs={12} sx={{ px: { xs: 1, sm: 3 }, mb: { xs: 2, sm: 3 } }} data-testid="performance-quick-stats">
      <Paper elevation={1} sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Grid container spacing={{ xs: 2, sm: 4 }}>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h4" 
                fontWeight="bold" 
                color="primary"
                sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
              >
                {summary.totalReviews}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {translateText('analytics.performance.totalReviews')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h4" 
                fontWeight="bold" 
                color="success.main"
                sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
              >
                {summary.completedReviews}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {translateText('analytics.performance.completed')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h4" 
                fontWeight="bold" 
                color="warning.main"
                sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
              >
                {summary.pendingReviews}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {translateText('analytics.performance.pending')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h4" 
                fontWeight="bold" 
                color="info.main"
                sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
              >
                {summary.averageRating.toFixed(1)}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {translateText('analytics.performance.avgRating')}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default PerformanceQuickStats;
